import { Timezones } from "@swivl-mono/helpers";
import { CountryCodeMap, LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetLayout, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { WorksheetComponent, WorksheetComponentType } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export default function LocationSubpageInformation() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
      <h4>{page.typeTitle} Information</h4>
      <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label={page.typeTitle + " Name"}
            keyName={LocationVarKey.Name}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label={page.typeTitle + " Number"}
            keyName={LocationVarKey.LocationNumber}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="Bot Name" keyName={LocationVarKey.BotName} />

          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="Address" keyName={LocationVarKey.Address} />
          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="City" keyName={LocationVarKey.City} />
          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="State" keyName={LocationVarKey.State} />

          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="Postal Code" keyName={LocationVarKey.PostalCode} />

          <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            label="Country"
            keyName={LocationVarKey.CountryCode}
            options={Object.values(CountryCodeMap).map((c) => ({
              label: c.name,
              value: c.code,
            }))}
          />

          <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            label="Timezone"
            keyName={LocationVarKey.Timezone}
            options={Timezones.map((c) => ({
              label: c,
              value: c,
            }))}
          />
        </WorksheetColumn>

        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label={page.typeTitle + " Website URL"}
            keyName={LocationVarKey.WebsiteURL}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="URL Lookup Pattern"
            keyName={LocationVarKey.URLLookupPattern}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label={page.typeTitle + " Email"}
            keyName={LocationVarKey.Email}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label={page.typeTitle + " Phone"}
            keyName={LocationVarKey.Phone}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="Pay by Phone"
            keyName={LocationVarKey.PayByPhoneNumber}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="After Hours Phone"
            keyName={LocationVarKey.AfterHoursPhoneNumber}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="DM Name" keyName={LocationVarKey.DMName} />
          <WorksheetComponent componentType={WorksheetComponentType.SINGLE_LINE} {...page} label="DM Email" keyName={LocationVarKey.DMEmail} />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
